import React from 'react';
import { Card, CardTitle, Typography, Button } from '@one-thd/sui-atomic-components';
import { useImpression } from '@thd-olt-component-react/impression';
import proptypes from 'prop-types';

const SubscriptionsFallback = ({ entryId }) => {
  const subscriptionsImage = 'https://dam.thdstatic.com/content/production/cj67U6r-FDISkAoDDaXiHA/'
  + 'LK2I_pIddi2Y9BVVVJjLJA/optimizedFile/2024_Hero1_Subscription_Service_Terms_Conditions_v2.jpg';
  const bulletPoints = [
    'Save 5% on every eligible subscription item',
    'Set it and forget it with automatic deliveries',
    'Modify or cancel subscriptions anytime'
  ];

  const { ref, clickID } = useImpression({
    data: {
      id: entryId || '',
      name: 'BuyAgainFallback',
      component: 'BuyAgain',
      position: 1,
      type: 'content',
    }
  });

  return (
    <Card
      data-component="BuyAgainSubscriptionsFallback"
      data-testid="buy-again-subscriptions-fallback"
      className="sui-h-full sui-@container"
      CardContentProps={{
        className: 'sui-flex sui-flex-col-reverse @3xl:sui-flex-row sui-w-full sui-gap-6 sui-p-4 sui-justify-between'
      }}
      ref={ref}
      clickid={clickID}
    >
      <div className="sui-flex sui-flex-col sui-gap-6">
        <CardTitle headerWeight="bold" header="Subscriptions" />
        <div>
          <Typography variant="h2" weight="display">Never Run Out of Your Favorites.</Typography>
          <Typography variant="h2" weight="display">Save 5% on subscription items.</Typography>
        </div>
        <ul className="sui-list-disc">
          {bulletPoints.map((str, index) => {
            return (<li className="sui-ml-8" key={index}>{str}</li>);
          })}
        </ul>
        <div className="sui-mt-auto">
          <Button
            variant="secondary"
            onClick={() => {
              window.location.href = '/c/subscription_service';
            }}
          >Explore Subscriptions
          </Button>
        </div>
      </div>
      <div className="sui-w-full sui-max-h-64 sui-overflow-hidden @3xl:sui-max-h-[100%] 
        @3xl:sui-min-w-[33%] @3xl:sui-max-w-[50%] @5xl:sui-max-w-[40%]">
        <img src={subscriptionsImage} className="sui-h-full sui-w-full sui-object-cover" alt="subscriptionsImage"/>
      </div>
    </Card>
  );
};

SubscriptionsFallback.propTypes = {
  entryId: proptypes.string
};

SubscriptionsFallback.defaultProps = {
  entryId: null
};

export { SubscriptionsFallback };